const styles = theme => ({
  root: {
    marginLeft: 'calc(100%)',
    marginTop: -37,
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      marginLeft: 270,
      marginTop: -37,
    },
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      marginLeft: 270,
      marginTop: -37,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/components/MessageButton/styles.js